import { render, staticRenderFns } from "./coldStorage.vue?vue&type=template&id=1e6a4863&scoped=true&"
import script from "./coldStorage.vue?vue&type=script&lang=js&"
export * from "./coldStorage.vue?vue&type=script&lang=js&"
import style0 from "./coldStorage.vue?vue&type=style&index=0&id=1e6a4863&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e6a4863",
  null
  
)

export default component.exports